/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc
 */
import * as References from './ProfilesRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#get
 */
export const GET_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_get';
export const GET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#doesProfileExist
 */
export const DOES_PROFILE_EXIST_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_doesProfileExist';
export const DOES_PROFILE_EXIST_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DOES_PROFILE_EXIST_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.doesProfileExistRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#getProfile
 */
export const GET_PROFILE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_getProfile';
export const GET_PROFILE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PROFILE_QUERY_FIELD_NAME,
  args: ['slug'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getProfileRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#getPreview
 */
export const GET_PREVIEW_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_getPreview';
export const GET_PREVIEW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PREVIEW_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getPreviewRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#upsertDraft
 */
export const UPSERT_DRAFT_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_upsertDraft';
export const UPSERT_DRAFT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPSERT_DRAFT_MUTATION_FIELD_NAME,
  args: ['listingEditRequest'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.upsertDraftRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#delete
 */
export const DELETE_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_delete';
export const DELETE_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.deleteRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#publish
 */
export const PUBLISH_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_publish';
export const PUBLISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: PUBLISH_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.publishRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#unpublish
 */
export const UNPUBLISH_MUTATION_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_unpublish';
export const UNPUBLISH_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNPUBLISH_MUTATION_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.unpublishRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesRpc#validateSlug
 */
export const VALIDATE_SLUG_QUERY_FIELD_NAME = 'com_hubspot_marketplace_profiles_rpc_ProfilesRpc_validateSlug';
export const VALIDATE_SLUG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: VALIDATE_SLUG_QUERY_FIELD_NAME,
  args: ['slug'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.validateSlugRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});